<template>
    <div class="mx-2 mx-lg-5">
        <div class="card my-3">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>{{ patrolRoute.name }}</h3>
                <div>
                    <button
                        v-if="$store.getters.hasGatehousePerm('change_patrollog')"
                        class="btn btn-sm btn-secondary me-3" @click="editRoute">
                        <icon icon="EditPen"></icon>
                    </button>
                    <button
                        v-if="$store.getters.hasGatehousePerm('delete_patrollog')"
                        class="btn btn-sm btn-danger"
                        @click="deleteRoute"
                    >
                        <icon icon="Trash"></icon>
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <div class="row mb-0">
                            <dt class="col-sm-4">{{ $t("patrolRoute.name") }}</dt>
                            <dd class="col-sm-8">{{ patrolRoute.name }}</dd>

                            <dt class="col-sm-4">{{ $t("patrolRoute.frequencyMinutes") }}</dt>
                            <dd class="col-sm-8">{{ patrolRoute.frequency_minutes }} min</dd>

                            <dt class="col-sm-4">{{ $t("patrolRoute.tagsCount") }}</dt>
                            <dd class="col-sm-8">{{ nfcTags.length }}</dd>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row mb-0">
                            <dt class="col-sm-4">{{ $t("patrolRoute.startedAt") }}</dt>
                            <dd class="col-sm-8">{{ patrolRoute.started_at ? patrolRoute.started_at.slice(0, 5) : "--" }}</dd>

                            <dt class="col-sm-4">{{ $t("patrolRoute.finishedAt") }}</dt>
                            <dd class="col-sm-8">{{ patrolRoute.finished_at ? patrolRoute.finished_at.slice(0, 5) : "--" }}</dd>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-header">
                <h3>{{ $t("nfcTag.location") }}</h3>
            </div>
            <div class="card-body">
                <div v-if="!nfcTags.length" class="mb-2 fw-bold text-center">
                    {{ $t("nfcTag.notFound") }}
                </div>
                <MapView
                    :nfcTags="nfcTags"
                />
            </div>
        </div>

        <div class="card">
            <div class="card-header">
                <h3>{{ $t("patrolRoute.history") }}</h3>
            </div>
            <div class="card-body">
                <PatrolLogTable
                    :patrolLogs="patrolLogs"
                    :success="getPatrolLogs"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import MapView from '@/components/dashboard/MapView.vue';
import PatrolLogTable from '@/components/dashboard/PatrolLogTable.vue';

export default {
    components: {
        Icon,
        MapView,
        PatrolLogTable,
    },
    data() {
        return {
            patrolRoute: {},
            nfcTags: [],
            patrolLogs: [],
        }
    },
    created() {
        this.getPatrolRoute();
        this.getNfcTags();
        this.getPatrolLogs();
    },
    methods: {
        getPatrolRoute() {
            this.$store.getters.api.get(`/dashboard/${this.$route.params.slug}/patrols/${this.$route.params.id}`)
            .then(response => {
                this.patrolRoute = response.data;
            })
            .catch(error => {
                console.error("Error loading patrol route.", error);
            });
        },
        editRoute() {
            this.$router.push({
                name: "PatrolRouteEditView",
                params: {
                    slug: this.$route.params.slug,
                    id: this.$route.params.id
                }
            })
        },
        deleteRoute() {
            const confirm = window.confirm(this.$t("utils.deleteConfirm", { name: this.patrolRoute.name }));
            if (!confirm) return;

            this.$store.getters.api.delete(`/dashboard/${this.$route.params.slug}/patrols/${this.$route.params.id}/delete`)
            .then(() => {
                this.$router.push({
                    name: "PatrolRouteListView",
                    params: {
                        slug: this.$route.params.slug
                    }
                });
            })
            .catch(error => {
                console.error("Error deleting patrol route.", error);
            });
        },
        getNfcTags() {
            this.$store.getters.api.get(`/dashboard/${this.$route.params.slug}/nfc`)
            .then(response => {
                this.nfcTags = response.data;
            })
            .catch(error => {
                console.error("Error loading nfc tags.",error);
            });
        },
        getPatrolLogs() {
            this.$store.getters.api.get(`/dashboard/${this.$route.params.slug}/patrols/${this.$route.params.id}/logs`)
            .then(res => {
                this.patrolLogs = res.data;
            })
            .catch(error => {
                console.error("Error loading patrol logs.", error);
            })
        }
    }
}
</script>